/**
 * Mobile detection utilities for responsive behavior
 */

/**
 * Check if the current device is mobile based on screen width
 * Uses Tailwind's md breakpoint (768px) as the threshold
 */
export const isMobile = (): boolean => {
  if (typeof window === 'undefined') return false;
  return window.innerWidth < 768;
};

/**
 * Check if the current device supports touch
 */
export const isTouchDevice = (): boolean => {
  if (typeof window === 'undefined') return false;
  return 'ontouchstart' in window || navigator.maxTouchPoints > 0;
};

/**
 * Check if the device is both mobile and touch-capable
 */
export const isMobileTouch = (): boolean => {
  return isMobile() && isTouchDevice();
};

/**
 * Get the current viewport width
 */
export const getViewportWidth = (): number => {
  if (typeof window === 'undefined') return 0;
  return window.innerWidth;
};

/**
 * Check if the device is in portrait orientation
 */
export const isPortrait = (): boolean => {
  if (typeof window === 'undefined') return false;
  return window.innerHeight > window.innerWidth;
};